<template>
  <v-content>
    <div id="core-view">
      <v-container>
        <v-breadcrumbs :items="items">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-container>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
export default {
  data: () => ({
    items: []
  }),
  created () {
    this.items = this.$route.meta.breadcrumb
  },
  watch: {
    '$route' () {
      this.items = this.$route.meta.breadcrumb
    }
  }
}
</script>
<style lang="scss" scoped>
.v-breadcrumbs {
  background: #eee;
}
</style>